exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#specialties{font-size:120%}#specialties__notification{min-width:auto}#specialties__notification button{display:none}#specialties .uppercase{text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/admin/specialties/specialties.styl
// module id = 55
// module chunks = 1